<template>
  <v-dialog v-model="dialog" width="900">
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        <v-icon color="green" class="mr-2">mdi-map-marker-radius-outline</v-icon>
        Seleziona Serra
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-progress-linear v-if="loading" indeterminate class="mb-2" />
        <template v-else-if="appezzamento_selezionato">
          <AppezzamentoCanvas
            :appezzamento="appezzamento_selezionato"
            :posizioni="posizioni_appezzamento"
            :serre="serre"
            :readonly="true"
            :hide_toolbar="true"
            :flat_mode="true"
            :evidenziate="selezionate"
            :max_height="520"
            :list_cols="5"
            :list_max_height="520"
            @serra-selezionata="toggleSerra"
          />
        </template>
        <v-alert v-else type="info" outlined dense class="mt-2">
          Nessun appezzamento configurato.
        </v-alert>
      </v-card-text>
      <v-divider />
      <v-card-text class="py-3" style="min-height: 40px">
        <div
          v-if="selezionate.length"
          class="d-flex flex-wrap align-center"
          style="gap: 4px; min-height: 24px"
        >
          <v-chip
            v-for="id_serra in selezionate"
            :key="id_serra"
            small
            outlined
            close
            color="green darken-1"
            @click:close="rimuovi(id_serra)"
          >
            {{ nomeSerra(id_serra) }}
          </v-chip>
        </div>
        <div
          v-else
          class="text-caption grey--text d-flex align-center"
          style="min-height: 24px"
        >
          Clicca una serra sulla mappa per selezionarla
        </div>
      </v-card-text>
      <v-alert
        v-if="require_selection && !selezionate.length"
        type="warning"
        outlined
        dense
        class="mx-4 mb-0 mt-2"
      >
        Seleziona almeno una serra prima di confermare.
      </v-alert>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">Annulla</v-btn>
        <v-btn
          outlined
          color="green"
          :disabled="require_selection && !selezionate.length"
          @click="conferma"
        >
          <v-icon class="mr-2">mdi-check</v-icon>Conferma
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AppezzamentoCanvas from "./AppezzamentoCanvas.vue";

export default {
  name: "SerraPickerDialog",
  components: { AppezzamentoCanvas },
  props: {
    value: { type: Array, default: () => [] },
    // Impedisce di confermare a selezione vuota. Usato dal flusso di
    // "sposta in un'altra serra" (SerraColturaElement): confermare senza
    // selezionare nulla azzererebbe serra_attuale, orfanizzando la coltura
    // (nessuna vista della mappa la elencherebbe più). Non tocca gli altri
    // usi (/stampa, QDC), dove una selezione vuota resta legittima.
    require_selection: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      appezzamento_selezionato: null,
      selezionate: [],
    };
  },
  computed: {
    appezzamenti() {
      return this.$store.getters.getAppezzamenti || [];
    },
    serre() {
      return this.$store.getters.getSerre || [];
    },
    posizioni_appezzamento() {
      if (!this.appezzamento_selezionato) return [];
      return this.$store.getters.getPosizioniAppezzamento(
        this.appezzamento_selezionato.id
      );
    },
  },
  watch: {
    appezzamento_selezionato(app) {
      if (!app) return;
      this.loading = true;
      this.$store
        .dispatch("fetchPosizioniAppezzamento", app.id)
        .finally(() => {
          this.loading = false;
        });
    },
  },
  methods: {
    open() {
      this.selezionate = [...this.value];
      // Nessuna selezione appezzamento in UI: si presume un solo appezzamento
      // (o comunque si parte dal primo disponibile) per tenere il picker
      // minimale. Se in futuro servissero più appezzamenti selezionabili,
      // qui va reintrodotto un modo di cambiarlo.
      if (!this.appezzamento_selezionato && this.appezzamenti.length) {
        this.appezzamento_selezionato = this.appezzamenti[0];
      }
      this.dialog = true;
    },
    toggleSerra(id_serra) {
      let index = this.selezionate.indexOf(id_serra);
      if (index > -1) {
        this.selezionate.splice(index, 1);
      } else {
        this.selezionate.push(id_serra);
      }
    },
    rimuovi(id_serra) {
      let index = this.selezionate.indexOf(id_serra);
      if (index > -1) {
        this.selezionate.splice(index, 1);
      }
    },
    nomeSerra(id_serra) {
      let serra = this.$store.getters.getSerraById(id_serra);
      return serra ? serra.nome : id_serra;
    },
    conferma() {
      this.$emit("input", [...this.selezionate]);
      this.$emit("conferma", [...this.selezionate]);
      this.dialog = false;
    },
  },
};
</script>
